// eslint-disable-next-line import/named
import { SvgIcon, SvgIconOwnProps } from '@mui/material';

import { theme } from '@components/mui/ThemeProvider';

const defaultIconProps: SvgIconOwnProps = {
  viewBox: '0 0 15 16',
  sx: { color: theme.palette.neutral.darker2 },
};

const LockIcon: React.FC<SvgIconOwnProps> = (props) => (
  <SvgIcon {...defaultIconProps} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.55844 8.45455C1.5119 8.45455 1.48176 8.47155 1.46526 8.48743C1.45866 8.49378 1.45455 8.50068 1.45455 8.50068V14.4993C1.45455 14.4993 1.45866 14.5062 1.46526 14.5126C1.48176 14.5285 1.5119 14.5455 1.55844 14.5455H12.987C13.0336 14.5455 13.0637 14.5285 13.0802 14.5126C13.0868 14.5062 13.0909 14.4993 13.0909 14.4993V8.50068C13.0909 8.50068 13.0868 8.49378 13.0802 8.48743C13.0637 8.47155 13.0336 8.45455 12.987 8.45455H1.55844ZM12.987 7H12.2078V4.75C12.2078 2.13125 9.99351 0 7.27273 0C4.55195 0 2.33766 2.13125 2.33766 4.75V7H1.55844C0.698052 7 0 7.67188 0 8.5V14.5C0 15.3281 0.698052 16 1.55844 16H12.987C13.8474 16 14.5455 15.3281 14.5455 14.5V8.5C14.5455 7.67188 13.8474 7 12.987 7ZM10.1818 7V4.75C10.1818 3.50938 9.16122 2.18182 7.27273 2.18182C5.38424 2.18182 4.36364 3.50938 4.36364 4.75V7H10.1818Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default LockIcon;
